import React, { useState, useEffect } from "react";
import ReceivedRequest from "./ReceivedRequest";
import { Button } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import DatePicker from "react-date-picker";
import Snackbar from "@mui/material/Snackbar";
import Typography from "@mui/material/Typography";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
const Accordian = ({ array, index, stack, setStack, remove, removeEntire }) => {
  const [expanded, setExpanded] = useState(false);
  let counter = 0;
  const [count, setCount] = useState(0);
  const [accepted, setAccepted] = useState(0);
  const [declined, setDeclined] = useState(0);
  const [height, setHeight] = useState(0);
  useEffect(() => {
    console.log(count);
  }, [count]);

  useEffect(() => {
    console.log(document.getElementById("stack-ext").clientHeight);
    setHeight(document.getElementById("stack-ext").clientHeight);
  }, [expanded]);

  // useEffect(() => {
  //   if (!expanded) {
  //     setOpenNorm()
  //   } else {
  //     document.getElementById("stack-ext").classList.remove("stack-hide");
  //     document.getElementById("stack-norm").classList.add("stack-hide");
  //   }
  // }, [expanded]);
  // (expanded ?
  //     document.getElementById('stack-norm').classList.add('stack-hide')
  //     // document.getElementById('stack-norm').classList.add(stack-hide)
  //     :
  //     null
  // )
  // Removing the card on Accepting or Declining the request
  //   const remove = (first, second) => {
  //     let localCards = [...stack];
  //     localCards[first].array.splice(second, 1);
  //     setStack(localCards);
  //   };
  if (array.length === 1) {
    // let array[0] = array[0];
    return (
      <>
        <ReceivedRequest
          name={array[0].name}
          desg={array[0].desg}
          slot={array[0].slot}
          id={array[0].id}
          status="pending"
          counter={counter}
          index={index}
          sIndex={0}
          remove={remove}
          cardId={"sup" + index + "sub" + count}
        />
        <hr className="my-2 border-gray-700" />
      </>
    );
  }
  return (
    <>
      <div
        className="box-shadow-request-card rounded-lg my-4"
        id="stack-container"
      >
        <div className="flex justify-between px-3 pt-2">
          <Typography
            variant="h5"
            component="h5"
            sx={{
              fontWeight: "bold",
            }}
          >
            {array.length} Requests for this slot
          </Typography>
          <IconButton
            aria-label="delete"
            size="large"
            onClick={() => {
              setExpanded(!expanded);
            }}
          >
            <KeyboardArrowDownIcon fontSize="inherit" />
          </IconButton>
          {/* <Button variant="outlined" size="large">
                      <KeyboardArrowDownIcon fontSize="inherit" />
                    </Button> */}
        </div>
        <div id="stack-cont">
          <div
            // className={expanded ? "stack-hide" : "stack-show"}
            id="stack-norm"
          >
            <ReceivedRequest
              name={array[count].name}
              desg={array[count].desg}
              slot={array[count].slot}
              id={array[count].id}
              status="pending"
              counter={counter}
              index={index}
              sIndex={count}
              remove={remove}
              cardId={"sup" + index + "sub" + count}
            />
          </div>
          <div
            className={expanded ? "stack-show " : "stack-hide "}
            // style={expanded ? null : { height: height }}
            // className={
            //   `${expanded ? "h-full overflow-auto" : "h-0 overflow-hidden"}` +
            //   " transition-all origin-top ease-in-out duration-1000"
            // }
            id="stack-ext"
          >
            {array.map((sItem, sIndex) => {
              return (
                <ReceivedRequest
                  name={sItem.name}
                  desg={sItem.desg}
                  slot={sItem.slot}
                  id={sItem.id}
                  status="pending"
                  remove={remove}
                  index={index}
                  sIndex={sIndex}
                  accepted={accepted}
                  setAccepted={setAccepted}
                  declined={declined}
                  setDeclined={setDeclined}
                  cardId={"sup" + index + "sub" + sIndex}
                />
              );
            })}
          </div>
        </div>
        {/* {!expanded ? (
          <ReceivedRequest
            name={array[count].name}
            desg={array[count].desg}
            slot={array[count].slot}
            id={array[count].id}
            status="pending"
            counter={counter}
            index={index}
            sIndex={count}
            remove={remove}
            cardId={"sup" + index + "sub" + count}
          />
        ) : (
          array.map((sItem, sIndex) => {
            return (
              <ReceivedRequest
                name={sItem.name}
                desg={sItem.desg}
                slot={sItem.slot}
                id={sItem.id}
                status="pending"
                remove={remove}
                index={index}
                sIndex={sIndex}
                accepted={accepted}
                setAccepted={setAccepted}
                declined={declined}
                setDeclined={setDeclined}
                cardId={"sup" + index + "sub" + sIndex}
              />
            );
          })
        )} */}
        <div className="grid grid-cols-3">
          <div className="col-span-1 flex justify-center">
            Accepted: {accepted} | Declined: {declined}
          </div>
          {!expanded ? (
            <div className="flex justify-center col-span-1">
              <IconButton
                aria-label="Previous Card"
                onClick={() => {
                  setCount(() => (count === 0 ? array.length - 1 : count - 1));
                  //   switchPrevCard();
                }}
              >
                <ArrowBackIosIcon fontSize="large" htmlColor="#000" />
              </IconButton>
              <div>
                {count + 1}/{array.length}
              </div>
              <IconButton
                aria-label="Next Card"
                onClick={() => {
                  setCount(() => (count < array.length - 1 ? count + 1 : 0));
                  //   switchNextCard();
                }}
              >
                <ArrowForwardIosIcon fontSize="large" htmlColor="#000" />
              </IconButton>
            </div>
          ) : (
            <div></div>
          )}
          <div className="relative flex justify-center col-span-1 mb-4">
            <Button
              variant="contained"
              sx={{
                backgroundColor: "green",
                marginRight: "10px",
              }}
              onClick={() => {
                removeEntire(index);
              }}
            >
              Accept All
            </Button>
            <Button
              variant="contained"
              sx={{ backgroundColor: "red" }}
              onClick={() => {
                removeEntire(index);
              }}
            >
              Decline All
            </Button>
          </div>
        </div>
      </div>
      <hr className="my-2 border-gray-700" />
    </>
  );
};

export default Accordian;
